module.exports = __webpack_public_path__ + "static/img/code-1.7405f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code-1.png
// module id = 5yXt
// module chunks = 0